import React from 'react';

import { FiChevronRight } from 'react-icons/fi';

import { Container } from './styles';
import { Check, Timer, VideoCamera } from 'phosphor-react';

interface ICardModuleProps {
  id: string;
  background: string;
  title: string;
  description: string;
  inputName: string;
  link: string;
  icon?: string;
  checked?: boolean;
  className?: string;
  countLessons?: number;
  totalDuration?: string;
  onClick(): void;
  bgColor?: string;
}

const CardModuleCheckbox: React.FC<ICardModuleProps> = ({ background, title, description, countLessons, totalDuration, checked, onClick, bgColor }) => {

  return (
    <>
      <Container background={background} onClick={onClick} checked={checked} bgColor={bgColor} className={checked ? 'checked' : ''}>
        <header>
          <div>
            <aside>
              {checked && <Check size={20} weight="bold" />}
            </aside>
            <h2>{title}</h2>
          </div>
          <p>{description}</p>
        </header>
        <footer>
          <div>
            <span>
              <VideoCamera weight="duotone" /> {countLessons} aulas
            </span>
            <span>
              <Timer weight="duotone" /> {totalDuration}
            </span>
          </div>
        </footer>
      </Container>
    </>
  );
}

export default CardModuleCheckbox;